import { z } from "zod";

export const ServerEnvVarsSchema = {
  SUPABASE_SECRET_KEY: z.string().min(1),
  JWT_IMPERSONATION_SECRET: z
    .string()
    .min(32, "JWT impersonation secret must be at least 32 characters"),
  REMOTION_AWS_ACCESS_KEY_ID: z.string().min(1),
  REMOTION_AWS_SECRET_ACCESS_KEY: z.string().min(1),
  REMOTION_AWS_SITE_NAME: z.string().optional(),
  RENDER_PROGRESS_WEBHOOK_SECRET: z.string().min(1),
  REMOTION_LICENSE_PUBLIC_KEY: z.string().optional(),
  RESEND_API_KEY: z.string(),
  RESEND_AUDIENCE_ID: z.string(),
  MUSIC_AI_API_KEY: z.string(),
  AUDIOSHAKE_API_KEY: z.string().min(1),
  STRIPE_SECRET_KEY: z.string().min(1),
  STRIPE_WEBHOOK_SECRET: z.string().min(1),
  ARCJET_KEY: z.string().min(1),

  TIGRIS_ENDPOINT: z.string().url().default("https://t3.storage.dev"),
  TIGRIS_ACCESS_KEY_ID: z.string().min(1),
  TIGRIS_SECRET_ACCESS_KEY: z.string().min(1),
  TIGRIS_MEDIA_BUCKET_NAME: z.string().min(1),
  TIGRIS_RENDERS_BUCKET_NAME: z.string().min(1),

  CLOUDFLARE_ACCOUNT_ID: z.string().min(1),
  CLOUDFLARE_R2_ACCESS_KEY_ID: z.string().min(1),
  CLOUDFLARE_R2_SECRET_ACCESS_KEY: z.string().min(1),
  CLOUDFLARE_R2_MEDIA_BUCKET_NAME: z.string().min(1),
  CLOUDFLARE_R2_PUBLIC_DOMAIN: z.string().min(1),
  CLOUDFLARE_STREAM_API_TOKEN: z.string().min(1),
  CLOUDFLARE_USE_MULTIPART_UPLOADS: z
    .string()
    // only allow "true" or "false"
    .refine((s) => s === "true" || s === "false")
    // transform to boolean
    .transform((s) => s === "true"),

  // Cog
  COG_API_URL: z.string().url(),
  COG_API_USERNAME: z.string().min(1),
  COG_API_PASSWORD: z.string().min(1),

  // Modal
  MODAL_ENDPOINT: z.string().url(),
  MODAL_LONG_ENDPOINT: z.string().url(),
  MODAL_ALIGN_ENDPOINT: z.string().url(),
  MODAL_ALIGN_LONG_ENDPOINT: z.string().url(),
  MODAL_KEY: z.string().min(1),
  MODAL_SECRET: z.string().min(1),

  GLEAP_SECRET_API_TOKEN: z.string().min(1),
  GOOGLE_FONTS_REDIS_CONN_STRING: z.string().min(1),

  PEXELS_API_KEY: z.string(),

  // LALAL.AI
  LALAL_AI_API_KEY: z.string().min(1),

  // Apify API token for YouTube audio extraction (youtubeLink primary, epctex +
  // truefetch fallbacks) — media is stored in Apify storage, so it downloads
  // from datacenter IPs. Shared by all actors.
  APIFY_API_KEY: z.string().min(1),
  // YouTube Data API key — authoritative video duration for billing/plan checks
  // on the paste-a-link path.
  YOUTUBE_DATA_API_KEY: z.string().min(1),

  // Optional variables
  CLOUDFLARE_TURNSTILE_SECRET_KEY: z.string().min(1).optional(),

  // VidKraken — primary YouTube download (audio + video). Optional on purpose:
  // when unset, YouTube downloads fall back to Apify (audio only).
  VIDKRAKEN_API_KEY: z.string().min(1).optional(),

  DOKPLOY_RENDER_URL: z.string().url().optional(),
  DOKPLOY_RENDER_TOKEN: z.string().min(1).optional(),

  LOCAL_TUNNEL_URL: z.string().url().optional(),

  BUNNY_API_KEY: z.string().optional(),

  GEMINI_API_KEY: z.string().min(1).optional(),
  GEMINI_TRANSLATION_MODEL: z
    .enum(["gemini-2.5-flash", "gemini-2.5-pro", "gemini-2.5-flash-lite"])
    .optional()
    .default("gemini-2.5-flash"),

  // Convex
  CONVEX_DEPLOYMENT: z.string().optional(),
  CONVEX_SERVICE_SECRET: z.string().optional(),

  FLAGS_CACHE_TTL: z.string().optional().default("300"),
};

export const ClientEnvVarsSchema = {
  NEXT_PUBLIC_SUPABASE_URL: z.string().min(1),
  NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY: z.string().min(1),
  NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
  NEXT_PUBLIC_MEDIA_BASE_URL: z.string().url(),

  // Optional variables
  NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY: z.string().min(1).optional(),
  NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
  NEXT_PUBLIC_GLEAP_API_KEY: z.string().optional(),
  NEXT_PUBLIC_SITE_URL: z.string().optional(),
  NEXT_PUBLIC_VERCEL_URL: z.string().optional(),

  // Convex
  NEXT_PUBLIC_CONVEX_URL: z.string().url().optional(),
};
